import { api } from '@/lib/api/client'
import type { Visibility } from '@/types/domain'
import { fetchAll } from '@/lib/api/paged'

export interface Comment {
  id: string
  body: string
  /** Rendered as a badge on every internal comment. The one field never omitted. */
  visibility: Visibility
  workItemId: string
  projectId: string
  createdAt: string | null
  updatedAt: string | null
  edited: boolean
  author?: { id: string; name: string; color: string | null } | null
  mentions?: { id: string; name: string }[]
}

export async function fetchComments(workItemId: string): Promise<Comment[]> {
  return fetchAll<Comment>(`/work-items/${workItemId}/comments`)
}

export async function postComment(
  workItemId: string,
  input: { body: string; visibility: Visibility },
): Promise<Comment> {
  const { data } = await api.post<{ data: Comment }>(`/work-items/${workItemId}/comments`, input)

  return data.data
}

export interface ItemLinks {
  blocks: { linkId: string; id: string; key: string; title: string; dueDate: string | null }[]
  blockedBy: { linkId: string; id: string; key: string; title: string; dueDate: string | null }[]
  related: { linkId: string; id: string; key: string; title: string }[]
}

export async function fetchLinks(workItemId: string): Promise<ItemLinks> {
  const { data } = await api.get<{ data: ItemLinks }>(`/work-items/${workItemId}/links`)

  return data.data
}

/** A comment is someone's own words; the server holds this to author-or-manager. */
export async function updateComment(
  id: string,
  changes: { body?: string; visibility?: Visibility },
): Promise<Comment> {
  const { data } = await api.patch<{ data: Comment }>(`/comments/${id}`, changes)

  return data.data
}

export async function deleteComment(id: string): Promise<void> {
  await api.delete(`/comments/${id}`)
}
